﻿<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="userId > 0">
            Edit User
        </h4>

        <h4 *ngIf="userId === 0">
            Add User
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">
            <div class="input-group">
                <label for="firstname">
                    First Name:<span class="required"> * </span>
                </label>
                <div>
                    <input name="firstname" #firstname="ngModel" type="text" placeholder="First Name" [class.invalid]="firstname.invalid" [(ngModel)]="user.firstname" required>
                    <div *ngIf="firstname.invalid">
                        <span class="error">First name is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="lastname">
                    Last Name:<span class="required"> * </span>
                </label>
                <div>
                    <input name="lastname" #lastname="ngModel" type="text" placeholder="Last Name" [class.invalid]="lastname.invalid" [(ngModel)]="user.lastname" required>
                    <div *ngIf="lastname.invalid">
                        <span class="error">Last name is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label>
                    User Type:<span class="required"> * </span>
                </label>
                <div class="toggle-group">
                    <button type="button" class="toggle-button" [class.active]="user.oktaGroup === 'Internal'" (click)="onOktaGroupChange('Internal')">Internal</button>
                    <button type="button" class="toggle-button" [class.active]="user.oktaGroup === 'External'" (click)="onOktaGroupChange('External')">External</button>
                </div>
            </div>

            <div class="input-group" *ngIf="!isExternal">
                <label for="employeeNumber">
                    Employee Number:<span class="required"> * </span>
                </label>
                <div>
                    <input name="employeeNumber" #employeeNumber="ngModel" type="text" placeholder="Employee Number" [class.invalid]="employeeNumber.invalid" [(ngModel)]="user.employeeNumber" required>
                    <div *ngIf="employeeNumber.invalid">
                        <span class="error">Employee number is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="username">
                    Username:<span class="required"> * </span>
                </label>
                <div>
                    <input name="username" #username="ngModel" type="email" placeholder="Username" [class.invalid]="username.invalid && (username.dirty || username.touched)" [(ngModel)]="user.username" required email >
                    <div *ngIf="username.invalid ||
                                (username.errors?.['required'] && (username.dirty || username.touched))" >
                        <span class="error">Username (email) is required</span>
                    </div>
                    <div *ngIf="username.errors?.['email'] && (username.dirty || username.touched)">
                        <span class="error">Please enter a valid email address</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="reviewer">
                    Reviewer:
                </label>
                <auto-complete-dropdown
                    [options]="reviewers"
                    [initialValue]="user.reviewerId"
                    [placeholder]="'Select Reviewer'"
                    [displayWith]="displayUserRole"
                    (selectionChange)="onReviewerSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <label for="tenants">
                    Tenants:<span class="required"> * </span>
                </label>

                <span class="pill-container">
                    <label *ngFor="let tenant of user.tenants" class="pill">
                        {{ tenant.name }}
                    </label>
                    <label *ngIf="!user.tenants || user.tenants.length === 0" class="pill gray">
                        Anonymous
                    </label>

                    <button type="button" title="Manage Tenants" class="pill-button" (click)="toggleTenantPanel()">
                        <i class="fas fa-cog"></i>
                    </button>
                </span>
                <div *ngIf="!user.tenants || user.tenants.length === 0">
                    <span class="error">At least one tenant is required</span>
                </div>
            </div>

            <div class="input-group">
                <label for="roles">
                    Roles:<span class="required"> * </span>
                </label>

                <span id="roles" names="roles" class="pill-container">
                    <label *ngFor="let role of user.roles" class="pill">
                        {{ role.name }}
                    </label>
                    <label *ngIf="!user.roles || user.roles.length === 0" class="pill gray">
                        Anonymous
                    </label>

                    <button type="button" title="Manage Roles" class="pill-button" (click)="toggleRolePanel()">
                        <i class="fas fa-cog"></i>
                    </button>
                </span>
                <div *ngIf="!user.roles || user.roles.length === 0">
                    <span class="error">At least one role is required</span>
                </div>
            </div>

            <div class="input-group">
                <label for="isActive">
                    Is Active:
                </label>
                <label class="switch">
                    <input name="isActive" #integratedSecurity="ngModel" type="checkbox" [(ngModel)]="user.isActive" />
                    <span class="slider">
                        <span class="toggle-text" [class.selected]="user.isActive">{{ user.isActive ? 'Yes' : 'No' }}</span>
                    </span>
                </label>
            </div>

            <div class="action-bar">
                <button type="submit" class="button">
                    <i class="fas fa-save"></i>
                    Save
                </button>
                <button type="button" class="button-cancel" (click)=" onCancel()">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>

<side-panel [isVisible]="isPanelOpen" [caption]="panelCaption" (onDone)="onPanelDone()" (onCancel)="onPanelCancel()">
    <!-- Tenants panel content -->
    <div *ngIf="isTenantPanel" class="sidebar">
        <div class="search-container">
            <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="panelSearch" (keydown.enter)="getTenants()">

            <button class="search-button" (click)="getTenants()">
                <i class="fas fa-magnifying-glass"></i>
            </button>
        </div>
        <div class="panel-list">
            <div *ngFor="let tenant of tenants" class="panel-item">
                <switch-control
                    name="isSelected-{{ tenant.id }}"
                    [(ngModel)]="tenant['isSelected']"
                    [label]="tenant.name">
                </switch-control>
            </div>
        </div>
    </div>

    <!-- Roles panel content -->
    <div *ngIf="!isTenantPanel" class="sidebar">
        <div class="search-container">
            <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="panelSearch" (keydown.enter)="getRoles()">

            <button class="search-button" (click)="getRoles()">
                <i class="fas fa-magnifying-glass"></i>
            </button>
        </div>
        <div class="panel-list">
            <div *ngFor="let role of roles" class="panel-item">
                <switch-control
                    name="isSelected-{{ role.id }}"
                    [(ngModel)]="role['isSelected']"
                    [label]="role.name">
                </switch-control>
            </div>
        </div>
    </div>
</side-panel>